module.exports = __webpack_public_path__ + "img/down_text_btm.2b620309.png";